/**
 * De tijdklok van de les: eerst de chattijd, dan de reflectietijd.
 *
 * Loopt de chattijd af, dan begint de reflectiefase (de leerlingen praten
 * alleen nog met Socrates) en gaat de klok opnieuw lopen met de
 * afrondingstijd van de stelling. Loopt die ook af, dan is het gesprek
 * voorbij en meldt de klok dat via bijEinde; het scherm gaat dan naar de
 * argumenten.
 *
 *   const klok = useTijdklok({ afrondingMinuten, bijReflectie, bijEinde });
 *   klok.start(session.chat_duur_min * 60);
 *   klok.seconden        null zolang de klok niet loopt
 *   klok.reflectieFase   true na de chattijd
 */
import { useEffect, useRef, useState } from 'react';

export function useTijdklok({ afrondingMinuten, bijReflectie, bijEinde }) {
  const [seconden, setSeconden] = useState(null);
  const [gestart, setGestart] = useState(false);
  const [reflectieFase, setReflectieFase] = useState(false);

  // De terugroepfuncties in een ref, zodat een nieuwe functie bij een
  // herrendering de klok niet opnieuw zet.
  const terug = useRef({ bijReflectie, bijEinde });
  terug.current = { bijReflectie, bijEinde };

  useEffect(() => {
    if (!gestart || seconden === null) return;
    if (seconden <= 0) {
      if (!reflectieFase) {
        setReflectieFase(true);
        setSeconden((afrondingMinuten || 5) * 60);
        terug.current.bijReflectie?.();
      } else {
        terug.current.bijEinde?.();
      }
      return;
    }
    const timer = setTimeout(() => setSeconden(seconden - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconden, gestart, reflectieFase, afrondingMinuten]);

  const start = (aantalSeconden) => {
    setSeconden(aantalSeconden);
    setGestart(true);
  };

  return { seconden, reflectieFase, start };
}
